const setPublicPath = () => {
  if (__webpack_public_path__.indexOf("http") === -1) {
    __webpack_public_path__ = window.assetUrl.replace(/\/?$/, "/");

    // eslint-disable-next-line no-console
    console.debug({
      __webpack_public_path__
    });
  }
};

export default setPublicPath;
